"use client";
import { useTranslation } from "@/lib/i18n";
import {
    ShieldCheckIcon,
    AlertTriangleIcon,
    ClipboardCheckIcon,
    FileTextIcon,
    WorkflowIcon,
    BrainCircuitIcon,
    UsersIcon,
    NetworkIcon,
} from "lucide-react";
import { Item, ItemIcon, ItemTitle, ItemDescription } from "../ui/item";
import { Section } from "../ui/section";

const features = (t: any) => [
    {
        icon: ShieldCheckIcon,
        title: t("items.f1_title"),
        description: t("items.f1_desc"),
    },
    {
        icon: AlertTriangleIcon,
        title: t("items.f2_title"),
        description: t("items.f2_desc"),
    },
    {
        icon: ClipboardCheckIcon,
        title: t("items.f3_title"),
        description: t("items.f3_desc"),
    },
    {
        icon: FileTextIcon,
        title: t("items.f4_title"),
        description: t("items.f4_desc"),
    },
    {
        icon: WorkflowIcon,
        title: t("items.f5_title"),
        description: t("items.f5_desc"),
    },
    {
        icon: BrainCircuitIcon,
        title: t("items.f6_title"),
        description: t("items.f6_desc"),
    },
    {
        icon: UsersIcon,
        title: t("items.f7_title"),
        description: t("items.f7_desc"),
    },
    {
        icon: NetworkIcon,
        title: t("items.f8_title"),
        description: t("items.f8_desc"),
    },
];

export default function Items() {
  const { t } = useTranslation("common");
    return (
        <Section id="solutions">
            <div className="mx-auto flex max-w-container flex-col items-center gap-6 sm:gap-20">
                <h2 className="max-w-[560px] text-center text-3xl font-semibold leading-tight sm:text-5xl sm:leading-tight">
                    {t("items.title")}
                </h2>
                <div className="grid auto-rows-fr grid-cols-2 gap-0 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4">
                    {features(t).map((feature: any) => (
                        <Item key={feature.title}>
                            <ItemTitle className="flex items-center gap-2">
                                <ItemIcon>
                                    <feature.icon className="h-5 w-5 stroke-1" />
                                    <div className="blur-md bg-primary h-1 w-1 absolute pe-4"></div>
                                </ItemIcon>
                                {feature.title}
                            </ItemTitle>
                            <ItemDescription>{feature.description}</ItemDescription>
                        </Item>
                    ))}
                </div>
            </div>
        </Section>
    );
}
